import { createApp } from 'vue'
import StafetDonationTaendLysStepThree from './StafetDonationTaendLysStepThree'

const el = '.kb-component--stafet-donation-taend-lys-step-three'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((StafetDonationTaendLysStepThreeDOM) => {
            const component = createApp(StafetDonationTaendLysStepThree).use(
                Store
            )
            component.mount(StafetDonationTaendLysStepThreeDOM)
        })
    }
}
